import { createContext, useState, useEffect } from "react";

import axios from "axios";

import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();
export default AuthContext;

export const AuthProvider = ({ children }) => {
  /////////////////////////////////////////////////////////////////

  const navigate = useNavigate();

  const [user, setuser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwt_decode(localStorage.getItem("authTokens"))
      : null
  );

  const [authTokens, setauthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );
  const [loading, setloading] = useState(true);

  const loginuser = async (e) => {
    e.preventDefault();
    let responce;

    try {
      responce = await axios.post(
        "https://pfebackend-zbz0.onrender.com/api/token/",
        {
          email: e.target.email.value,
          password: e.target.password.value,
        }
      );
    } catch (error) {
      alert("wrong username or password");
      return;
    }

    if (responce.status === 200) {
      const user22 = jwt_decode(JSON.stringify(responce.data.access));
      console.log(user22);

      if (!user22.active) {
        navigate("/verifyemail");
        return;
      }

      setauthTokens(responce.data);
      setuser(jwt_decode(responce.data.access));
      localStorage.setItem("authTokens", JSON.stringify(responce.data));
      navigate("/");
      window.location.reload();
    }
  };

  const logoutuser = () => {
    setauthTokens(null);
    setuser(null);
    localStorage.removeItem("authTokens");
    navigate("/login");
  };

  const updatToken = async () => {
    console.log("updatToken called");
    let responce;

    try {
      responce = await axios.post(
        "https://pfebackend-zbz0.onrender.com/api/token/refresh/",
        {
          refresh: JSON.parse(localStorage.getItem("authTokens")).refresh,
        }
      );
    } catch (error) {
      setauthTokens(null);
      setuser(null);
      return;
    }
    const newtokens = {
      access: responce.data.access,
      refresh: authTokens.refresh,
    };
    setauthTokens(newtokens);
    setuser(jwt_decode(responce.data.access));
    localStorage.setItem("authTokens", JSON.stringify(newtokens));
    if (loading) {
      setloading(false);
    }
  };

  let contextData = {
    user: user,
    loginuser: loginuser,
    logoutuser: logoutuser,
    authTokens: authTokens,
  };

  useEffect(() => {
    if (loading && localStorage.getItem("authTokens")) {
      updatToken();
    }

    if (authTokens) {
      const interval = setInterval(() => {
        updatToken();
      }, 2000 * 60 * 4); // 4 minutes 2000 * 60 * 4 2000 * 60 * 60 * 24 * 30 2000 * 60 * 60 * 24 * 30 * 12 2000 * 60 * 60 * 24 * 30 * 12 * 5 2000 * 60 * 60 * 24 * 30 * 12 * 5 * 10 2000 * 60 * 60 * 24 * 30 * 12 * 5 * 10 * 100
      return () => clearInterval(interval);
    }
  }, [authTokens, loading]);

  return (
    <AuthContext.Provider value={{ contextData }}>
      {children}
    </AuthContext.Provider>
  );
};
